<script>
import Vue from 'vue';
import axios from 'axios';
import Donut from 'vue-css-donut-chart';
import EsMatch from '@/components/EsMatch.vue';
import EsNearMatch from '@/components/EsNearMatch.vue';
import PermissionManager from '@/mixins/PermissionManager';
import 'vue-css-donut-chart/dist/vcdonut.css';
import FieldLabels from '@/mixins/FieldLabels';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  mapActions,
  mapGetters,
} from 'vuex';
import {
  faAngleDoubleRight,
  faBan,
  faCaretDown,
  faCaretUp,
  faCheck,
} from '@fortawesome/pro-solid-svg-icons';
import {
} from '@fortawesome/pro-light-svg-icons';

library.add(
  faAngleDoubleRight,
  faBan,
  faCaretDown,
  faCaretUp,
  faCheck,
);

Vue.use(Donut);

export default {
  mixins: [
    PermissionManager,
    FieldLabels,
  ],
  props: {
    id: {
      type: Number,
      required: false,
    },
    lowerBound: {
      type: String,
      required: false,
    },
    organizations: {
      type: Array,
      required: true,
    },
    matchPercent: {
      type: Number,
      required: false,
    },
    response: {
      // type: Object,
      required: false,
    },
    request: {
      // type: Object,
      required: true,
    },
    singleMatch: {
      type: Boolean,
      required: true,
    },
    upperBound: {
      type: String,
      required: false,
    },
  },
  components: {
    EsMatch,
    EsNearMatch,
  },
  data() {
    return {
      isExpanded: null,
      loading: false,
      loadingOrgs: false,
      matchResponse: null,
      showModal: false,
    };
  },
  async created() {
    await this.loadPersonTypes();
    this.isExpanded = false;
    this.getDetails();
  },
  computed: {
    ...mapGetters('lookups', [
      'defaultPersonType',
    ]),
    organizationName() {
      const organization = this.organizations[this.organizations.map(o => { return o.code; }).indexOf(this.request.locationOrganization.organizationCode)];
      if (organization) {
        return organization.name;
      }
      return '--';
    },
    roundmatchPercent() {
      if (!this.singleMatch) {
        return Math.round(this.matchPercent * 100);
      } else if (this.matchResponse !== null) {
        return this.matchResponse.locationPotentialMatches[0].percent;
      }
      return 0
    },
    potentialNearMatches() {
      if (this.matchResponse.locationPotentialMatches !== null) {
        return this.matchResponse.locationPotentialMatches.length;
      }
    },
  },
  methods: {
    ...mapActions('lookups', [
      'loadPersonTypes',
    ]),
    associatedOrganizations(nearMatch) {
      let orgs = '';
      for (let i = 0; i < nearMatch.locationOrganizations.length; i += 1) {
        if (i >= 1) {
          orgs += ', '
        }
        orgs += nearMatch.locationOrganizations[i].organization.name;
      }
      return orgs;
    },
    goToComparePage() {
      this.$router.push({ name: 'compareMatches', params: { nearMatchId: this.id } });
    },
    isUpperBound(percent) {
      if (percent >= this.upperBound) {
        return true;
      }
      return false;
    },
    modalClose() {
      this.showModal = false;
    },
    modalOpen() {
      this.showModal = true;
    },
    async createMatch(idForAssign) {
      try {
        const res = await axios.put(`search/location/nearmatches/${this.matchResponse.requestId}`, { command: 'ASSIGN_ID', stateLocationIdForAssign: idForAssign });
        const { newLocationIdAssigned } = res.data;
        const { transStatus } = res.data;
        // LOCID_NEAR_MATCH_RESOLVE_BY_ASSIGN_ID
        this.$router.push({
          name: 'locationDetails',
          params: { id: newLocationIdAssigned, transStatus },
        });
      } catch {
        // handle
      }
    },
    async getDetails() {
      try {
        const res = await axios.get(`search/location/nearmatches/${this.id}/details`);
        this.matchResponse = res.data.response;
      } catch {
        // handle error
      }
    },
    async getLocationProfile() {
      this.loadingOrgs = true;
      for (let i = 0; i < this.matchResponse.locationPotentialMatches.length; i += 1) {
        try {
          const res = await axios.get(`locations/${this.matchResponse.locationPotentialMatches[i].id}/profile`);
          this.matchResponse.locationPotentialMatches[i].locationOrganizations = res.data.locationOrganizations;
        } catch {
          // handle error
        }
      }
      this.loadingOrgs = false;
    },
    async notMatch() {
      try {
        const res = await axios.put(`search/location/nearmatches/${this.matchResponse.requestId}`, { command: 'CREATE_NEW' });
        const idCreated = res.data.newLocationIdAssigned;
        const { transStatus } = res.data;
        // LOCID_NEAR_MATCH_RESOLVE_BY_CREATE_NEW
        this.$router.push({
          name: 'locationDetails',
          params: { id: idCreated, transStatus },
        });
      } catch {
        // handle error
      }
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
      if (this.isExpanded) {
        this.getLocationProfile();
      }
    },
  },
};
</script>

<template lang="html">
  <div class="document">
    <div v-if="showModal" class="modal is-active">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title has-text-weight-bold">Confirm Decision</p>
          <button
            class="delete"
            aria-label="close"
            @click="modalClose">
          </button>
        </header>
        <section class="modal-card-body">
          <div class="modal-body">
            Are you sure you want to select No Match and create a new {{ getFieldLabel(`PER:${defaultPersonType}:ASSIGN:STATE_STUDENT_ID`) }}?
          </div>
          <div class="is-flex flex-justify--end flex-align--center">
            <a @click="modalClose">Cancel</a>
            <button
              class="button is-primary margin-left"
              @click="notMatch">
                Yes, Create a New {{ getFieldLabel(`PER:${defaultPersonType}:ASSIGN:STATE_STUDENT_ID`) }}
            </button>
          </div>
        </section>
      </div>
    </div>
    <div class="card-container">
      <div class="card--heading is-flex">
        <div class="card-cell is-flex flex-direction--column overflow--ellipsis">
          <div class="card-cell--title">
            Submission Record
          </div>
          <div class="has-text-left is-flex">
            <div class="card-cell--body is-size-4 overflow--ellipsis">
              {{ request.location.name }}
            </div>
            <div
              class="is-italic has-text-grey is-flex flex-align--center padding--left"
            >
              ({{ request.locationOrganization.localCode }})
            </div>
          </div>
        </div>
        <div class="card-cell is-flex flex-direction--column border--left flex-justify--center margin-left--auto">
          <div class="is-size-4 has-text-weight-bold has-text-left">
            <span>
              {{ request.location.street1 }}
            </span>
            <span v-if="request.location.street2">
              {{ request.location.street2 }}
            </span>
          </div>
          <div class="is-size-4 has-text-weight-bold has-text-left">
            <span>
              {{ request.location.city }},
            </span>
            <span>
              {{ request.location.stateCode }}
            </span>
            <span>
              {{ request.location.zip }}
            </span>
          </div>
        </div>
        <div class="card-cell is-flex flex-direction--column border--left">
          <div class="card-cell--title">
            Organization
          </div>
          <div
            v-if="request.locationOrganization.organizationCode"
            class="is-size-4 has-text-left has-text-weight-bold"
          >
            {{ organizationName }}
          </div>
        </div>
        <div class="card-cell is-flex border--left flex-direction--row flex-align--center">
          <div class="padding-right">
            <vc-donut
              :size="60"
              :sections="[{ value: roundmatchPercent, color: '#474282' },
              { value: 100 - roundmatchPercent, color: '#C8C8C8'}]">
              <h1 class="percent-label">{{ roundmatchPercent }}%</h1>
            </vc-donut>
          </div>
          <div class="has-text-left has-text-grey">
            <div class="">
              Max
            </div>
            <div class="">
              Match
            </div>
            <div class="">
              Score
            </div>
          </div>
        </div>
        <div class="card-cell is-flex border--left flex-direction--row flex-align--center">
          <div
            v-if="matchResponse"
            class="has-text-weight-bold is-size-3 padding-right"
          >
            {{ potentialNearMatches }}
          </div>
          <div v-else class="has-text-weight-bold is-size-3 padding-right">
            -
          </div>
          <div class="has-text-grey">
            <div class="">
              Potential
            </div>
            <div class="">
              Matches
            </div>
          </div>
        </div>
        <div class="card-cell is-flex border--left flex-direction--row flex-align--center">
          <a>
            <font-awesome-icon
              class="is-primary"
              v-if="!isExpanded"
              :icon="['fas', 'caret-down']"
              @click="toggleExpand"
              title="Expand"
              size="lg"/>
            <font-awesome-icon
              class="is-primary"
              v-else
              @click="toggleExpand"
              :icon="['fas', 'caret-up']"
              title="Collapse"
              size="lg"/>
          </a>
          <a class="margin--left" v-if="hasModule('LOCID:MATCH:RESOLVENM:NOMATCH:CREATEID')">
            <font-awesome-icon
              class="is-primary"
              :icon="['fas', 'ban']"
              title="Not Match"
              @click="modalOpen()"
              size="lg"/>
          </a>
          <a class="margin--left">
            <font-awesome-icon
              class="is-primary"
              :icon="['fas', 'angle-double-right']"
              title="Compare Near Matches"
              @click="goToComparePage"
              size="lg"/>
          </a>
        </div>
      </div>
      <div class="card--body" v-if="isExpanded">
        <div class="has-text-left border--bottom has-text-weight-bold">Potential Matches to Master Data</div>
        <table class="table is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th></th>
              <th>Location Name</th>
              <th>Address Information</th>
              <th>Associated Organizations</th>
              <th>Match Score</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody v-if="matchResponse.locationPotentialMatches !== null">
            <tr v-for="nearMatch in matchResponse.locationPotentialMatches" :key="nearMatch.id">
              <td class="padding--none">
                <es-match
                  v-if="isUpperBound(nearMatch.percent)"
                />
                <es-near-match
                  v-else
                />
              </td>
              <td>{{ nearMatch.id }} - {{ nearMatch.matchedObject.name }}</td>
              <td>
                <div class="">
                  <span>
                    {{ nearMatch.matchedObject.street1 }}
                  </span>
                  <span v-if="nearMatch.matchedObject.street2">
                    {{ nearMatch.matchedObject.street2 }}
                  </span>
                </div>
                <div class="">
                  <span>
                    {{ nearMatch.matchedObject.city }},
                  </span>
                  <span>
                    {{ nearMatch.matchedObject.stateCode }}
                  </span>
                  <span>
                    {{ nearMatch.matchedObject.zip }}
                  </span>
                </div>
              </td>
              <td v-if="loadingOrgs"> -- </td>
              <td v-else>{{ associatedOrganizations(nearMatch) }}</td>
              <td>
                <vc-donut
                  :size="50"
                  :sections="[{ value: nearMatch.percent, color: '#474282' },
                    { value: 100 - nearMatch.percent, color: '#C8C8C8'}]">
                  <h2 class="percent-label is-size-6">{{ nearMatch.percent }}%</h2>
                </vc-donut>
              </td>
              <td style="">
                <a v-if="hasModule('LOCID:MATCH:RESOLVENM:MATCHDEC')">
                  <font-awesome-icon
                    class="is-primary"
                    :icon="['fas', 'check']"
                    size="lg"
                    @click="createMatch(nearMatch.id)"
                    title="Match"/>
                </a>
                <a class="margin--left">
                  <font-awesome-icon
                    class="is-primary"
                    :icon="['fas', 'angle-double-right']"
                    size="lg"
                    @click="goToComparePage"
                    title="Compare Near Matches"/>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
  .document
    margin-bottom: 1rem
  .card-container
    padding-top: 0.5rem
  .card--holder
    max-width: 100%
  .card--heading
    min-height:  70px
  .card--body
    padding: 1.5rem 4rem
    max-width: 100%
  .card-cell
    padding: 0 1rem
    margin-bottom: 0.5rem
  .card-cell--title
    padding: 0.5rem 0
    color: #999
    font-size: 12px
    text-align: left
  .border--left
    border-left: 1px solid #ccc
  .border--bottom
    border-bottom: 1px solid #ccc

  .padding-right
    padding-right: 1rem
  .padding--left
    padding-left: 1rem
  .margin--left
    margin-left: 1rem
  .margin-left--auto
    margin-left: auto
  .overflow--ellipsis
    overflow: hidden
    text-overflow: ellipsis
  .padding--none
    padding: 0px !important

  .modal-card-title
    display: flex
  .modal-body
    margin-bottom: 1rem
    display: flex
    justify-content: flex-start

  // global
  .margin-left
    margin-left: 1rem

  .percent-label
    font-style: bold
    color: black
    font-size: 1.1rem
    font-weight: 800
    padding: .25rem 0 .25rem .15rem
</style>
